import React, { useEffect, useState } from "react";
import InnoIcons from "InnoUI/innoicons";
import theme from "theme";
import SmartBlub from "../../../../../assets/Smartbulb.png";
import DefaultBulb from "../../../../../assets/defaultbulb.png";
import { folderTypesMatch } from "utils/optionData/utils";
import SC from "./style";
import DeleteComponent from "views/AdminSettings/DeleteComponent";
import { apiGet, apiPost } from "api/callApi";
import { DetailDrawer, Popover, TableList } from "InnoUI/components";
import RolePermissions from "../../FolderProjectStructure/RolePermissions";
import ViewRole from "../ViewRole";
import { allFolderType } from "utils/lookUpTable";
import { showAlert } from "utils/helper";
import { useNavigate } from "react-router";
import FolderDeleteReview from "../FolderDeleteReview";
const Folder = (props) => {
  const {
    folder,
    addSubFolder,
    updateFolder = () => {},
    fetchData = () => {},
    popupState,
    handleEditModal = () => {},
    handleAddSubFolder = () => {},
    isManageFolder = false,
  } = props;
  const [isOpen, setIsOpen] = useState(true);
  const [openDeleteView, setOpenDeleteView] = useState(false);
  const [openDeleteReview, setOpenDeleteReview] = useState(false);
  const [open, setOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const navigate = useNavigate();

  const { REACT_APP_REPORT_COLUMNS } = process.env;
  const reportColumn = JSON.parse(REACT_APP_REPORT_COLUMNS);

  const toggleFolder = () => setIsOpen(!isOpen);

  const closeDrawer = () => {
    setOpen(false);
  };

  const openDeleteModal = () => {
    setOpenDeleteReview(true);
  };

  const removeFolder = async (folderId, deleteOptions = {}) => {
    try {
      setIsDeleting(true);
      const response = await apiPost(
        `/v1/projectfolder/deletefolder/${folderId}`,
        deleteOptions,
      );
      showAlert({ title: "Success", text: response?.message, icon: "success" });
      await fetchData();
      setOpenDeleteView(false);
      setOpenDeleteReview(false);
      if (isManageFolder) {
        navigate(0);
      }
    } catch (error) {
      showAlert({
        title: "Error",
        text: error.response?.data?.message || "Failed to delete folder",
        icon: "error",
      });

      console.log("Error: " + error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleOpenPermissions = () => {
    setOpen(true);
  };

  const folderType = folderTypesMatch.find(
    (item) => item.id === folder.folderType,
  );
  const folderIcon = folderType ? folderType.icon : "📂";

  // canAccessfolderTypes.folder

  const isDeleteDisabled = (folder) => {
    console.log(folder, "kl");

    const nonDeletableTypes = new Set([
      allFolderType.Address_Book,
      allFolderType.Journal,
      allFolderType.Info,
      allFolderType.Photos,
    ]);

    // Type-based restriction
    if (nonDeletableTypes.has(folder.folderType)) return true;

    // Special rule for Documents with ReleasedOn
    if (
      folder.folderType === allFolderType.Document &&
      folder.reportColumnId === reportColumn.ReleasedOn
    ) {
      return true;
    }

    return false;
  };

  const menuItems = [
    ...(folder.folderType === allFolderType.Folder
      ? [
          {
            id: 1,
            text: "Add Sub folder",
            onClick: () => handleAddSubFolder(folder),
          },
        ]
      : []),

    {
      id: 2,
      text: "Edit",
      onClick: () => handleEditModal(folder),
    },
    {
      id: 3,
      text: "Permission To Folder",
      onClick: handleOpenPermissions,
    },
    ...(isDeleteDisabled(folder)
      ? []
      : [
          {
            id: 4,
            text: "Delete",
            onClick: openDeleteModal,
          },
        ]),
  ];

  return (
    <>
      <SC.FolderContainer>
        <SC.FolderHeader>
          <SC.FolderName>
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <SC.FolderIcon>{isOpen ? folderIcon : "📁"}</SC.FolderIcon>
              <SC.PopoverContainer>
                <span>{folder.sortOrder}</span>
                {/* <SC.ValueSpanP>{folder.name || ""}</SC.ValueSpanP> */}

                <SC.ValueSpanP>
                  {folder.name}
                  {folder.folderType == 2 && `(${folder.fileCount})`}{" "}
                  {folder.folderType == 1 && `(${folder.children.length})`}
                </SC.ValueSpanP>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    marginRight: "5px",
                  }}
                >
                  <span className="lock-icon">
                    {folder.privacy === 1 ? (
                      <InnoIcons.LockIcon
                        sx={{
                          color: theme.colors.themeColor,
                          fontSize: "15px",
                        }}
                      />
                    ) : (
                      <InnoIcons.LockOpenIcon
                        sx={{ fontSize: "15px", opacity: 0.7 }}
                      />
                    )}
                  </span>
                  <span className="lock-icon">
                    <img
                      src={folder.isSmart === 0 ? DefaultBulb : SmartBlub}
                      alt=""
                      style={{ width: "15px", height: "15px" }}
                    />
                  </span>
                </div>
                <SC.PopoverSpan>
                  <Popover
                    sx={{
                      cursor: "pointer",
                    }}
                    buttonLabel={{
                      icon: <SC.MoreVertIcon />,
                    }}
                    popoverContent={
                      <TableList
                        sx={{
                          borderBottom: `1px solid ${theme.colors.bordertask}`,
                        }}
                        items={menuItems || []}
                        popupState={popupState}
                      />
                    }
                  />
                </SC.PopoverSpan>
              </SC.PopoverContainer>
            </div>

            <div>
              <ViewRole folder={folder} fetchData={fetchData} />
            </div>
          </SC.FolderName>
        </SC.FolderHeader>
        {isOpen && (
          <div className="folder-children">
            {folder.children.map((child) => (
              <Folder
                key={child.id}
                folder={child}
                addSubFolder={addSubFolder}
                removeFolder={removeFolder}
                updateFolder={updateFolder}
                handleEditModal={handleEditModal}
                handleAddSubFolder={handleAddSubFolder}
                fetchData={fetchData}
                isManageFolder={isManageFolder}
              />
            ))}
          </div>
        )}
      </SC.FolderContainer>

      {openDeleteReview && (
        <DetailDrawer
          open={openDeleteReview}
          onClose={() => setOpenDeleteReview(false)}
          title={false}
          width={"700px"}
          children={
            <FolderDeleteReview
              folderId={folder.id}
              folderName={folder.name}
              folderType={folder.folderType}
              onConfirmDelete={(deleteOptions) =>
                removeFolder(folder.id, deleteOptions)
              }
              onCancel={() => setOpenDeleteReview(false)}
              isDeleting={isDeleting}
            />
          }
        ></DetailDrawer>
      )}

      {openDeleteView && (
        <DeleteComponent
          title={"Delete Folder"}
          messageData={`Are you sure you want to Delete this ${folder.name} `}
          setOpenDeleteView={setOpenDeleteView}
          openDeleteView={openDeleteView}
          handleDelete={() => removeFolder(folder.id)}
          handleArchive={() => setOpenDeleteView(false)}
          firstButtontext={"Cancel"}
          isLoading={isDeleting}
        />
      )}

      {open && (
        <DetailDrawer
          open={open}
          onClose={closeDrawer}
          title={false}
          width={"650px"}
          children={
            <RolePermissions
              onClose={closeDrawer}
              folder={folder}
              refreshFolders={fetchData}
              isManageFolder={isManageFolder}
            />
          }
        ></DetailDrawer>
      )}
    </>
  );
};

export default Folder;
